// Flash card content per subject + topic.
// Each card is a simple front/back style: title (term) and description (kid-friendly definition).

export const FLASHCARD_TOPIC_CONTENT = {
  maths: {
    "number-place-value": [
      {
        title: "Place Value",
        description: "Tells you how much a digit is worth depending on where it sits (ones, tens, hundreds, thousands…).",
        icon: "📍",
        cardType: "place-value",
        placeValue: {
          number: 124,
          hundreds: 1,
          tens: 2,
          ones: 4,
          question: "What is the value of the 1?",
          answer: "100",
        },
        examples: [
          {
            placeValue: {
              number: 124,
              hundreds: 1,
              tens: 2,
              ones: 4,
              question: "What is the value of the 1?",
              answer: "100",
            },
          },
          {
            placeValue: {
              number: 325,
              hundreds: 3,
              tens: 2,
              ones: 5,
              question: "What is the value of the 2?",
              answer: "20",
            },
          },
          {
            placeValue: {
              number: 52,
              hundreds: 0,
              tens: 5,
              ones: 2,
              question: "What is the value of the 2?",
              answer: "2",
            },
          },
        ],
      },
      {
        title: "Value of the underlined digit",
        description: "Write down the value of the underlined digit (how much that digit is worth in its place).",
        icon: "📍",
        cardType: "place-value-worksheet",
        placeValueWorksheet: {
          items: [
            { label: "a", number: "25", underlinedDigit: "5", answer: "5" },
            { label: "b", number: "9.8", underlinedDigit: "9", answer: "9" },
            { label: "c", number: "365", underlinedDigit: "3", answer: "300" },
            { label: "d", number: "147", underlinedDigit: "4", answer: "40" },
          ],
        },
      },
      {
        title: "Write the numbers in words",
        description: "Write the numbers below in words.",
        icon: "📝",
        cardType: "numbers-in-words-worksheet",
        numbersInWordsWorksheet: {
          items: [
            { label: "a", number: "38", answer: "thirty-eight" },
            { label: "b", number: "165", answer: "one hundred and sixty-five" },
            { label: "c", number: "443", answer: "four hundred and forty-three" },
            { label: "d", number: "258", answer: "two hundred and fifty-eight" },
            { label: "e", number: "1025", answer: "one thousand and twenty-five" },
          ],
        },
      },
      {
        title: "Arrange the numbers in ascending order",
        description: "Arrange the numbers below in ascending order (smallest to largest).",
        icon: "↗️",
        cardType: "ascending-order-worksheet",
        ascendingOrderWorksheet: {
          items: [
            { label: "a", numbers: "15, 5, 50, 25, 20, 18", answer: "5, 15, 18, 20, 25, 50" },
            { label: "b", numbers: "103, 10, 3, 113, 23, 73", answer: "3, 10, 23, 73, 103, 113" },
          ],
        },
      },
      {
        title: "Arrange the numbers in descending order",
        description: "Arrange the numbers below in descending order (largest to smallest).",
        icon: "↘️",
        cardType: "descending-order-worksheet",
        descendingOrderWorksheet: {
          items: [
            { label: "a", numbers: "14, 58, 24, 106, 180, 4", answer: "180, 106, 58, 24, 14, 4" },
            { label: "b", numbers: "32, 23, 102, 132, 123, 2", answer: "132, 123, 102, 32, 23, 2" },
          ],
        },
      },
      {
        title: "Write the correct comparison symbol (<, >, =)",
        description: "Write the correct comparison symbol for the following numbers.",
        icon: "⚖️",
        cardType: "comparison-symbol-worksheet",
        comparisonSymbolWorksheet: {
          items: [
            { label: "a", left: "12", right: "24", answer: "<" },
            { label: "b", left: "103", right: "93", answer: ">" },
            { label: "c", left: "16 − 5", right: "11 + 5", answer: "<" },
            { label: "d", left: "17 − 1", right: "15 + 1", answer: "=" },
            { label: "e", left: "82 + 8", right: "75 + 1", answer: ">" },
          ],
        },
      },
      {
        title: "Digit",
        description: "A single number symbol from 0 to 9 that we use to build bigger numbers.",
        icon: "🔢",
        cardType: "digit",
        digit: { examples: [3, 7, 9], question: "How many digits are in the number 357?", answer: "3 digits" },
        examples: [
          { digit: { examples: [3, 7, 9], question: "How many digits are in the number 357?", answer: "3 digits" } },
          { digit: { examples: [4, 2, 1, 8], question: "How many digits are in the number 4218?", answer: "4 digits" } },
          { digit: { examples: [9], question: "How many digits are in the number 9?", answer: "1 digit" } },
        ],
      },
      {
        title: "Round to nearest 10",
        description: "if it is 4 or less, round down.",
        icon: "🔄",
        cardType: "rounding",
        rounding: { number: 36, question: "Round 36 to the nearest 10.", answer: "40" },
        examples: [
          { rounding: { number: 36, question: "Round 36 to the nearest 10.", answer: "40" } },
          { rounding: { number: 54, question: "Round 54 to the nearest 10.", answer: "50" } },
          { rounding: { number: 88, question: "Round 88 to the nearest 10.", answer: "90" } },
        ],
      },
      {
        title: "Round to the nearest ten",
        description: "Round the numbers below to the nearest 10.",
        icon: "🔄",
        cardType: "round-to-nearest-worksheet",
        roundToNearestWorksheet: {
          items: [
            { label: "a", number: "33", answer: "30" },
            { label: "b", number: "85", answer: "90" },
            { label: "c", number: "42", answer: "40" },
            { label: "d", number: "72", answer: "70" },
            { label: "e", number: "166", answer: "170" },
            { label: "f", number: "299", answer: "300" },
          ],
        },
        examples: [
          {
            roundToNearestWorksheet: {
              items: [
                { label: "a", number: "24", answer: "20" },
                { label: "b", number: "67", answer: "70" },
                { label: "c", number: "95", answer: "100" },
              ],
            },
          },
          {
            roundToNearestWorksheet: {
              items: [
                { label: "a", number: "128", answer: "130" },
                { label: "b", number: "251", answer: "250" },
                { label: "c", number: "384", answer: "380" },
              ],
            },
          },
        ],
      },
      {
        title: "Round to the nearest hundred",
        description: "Round the numbers below to the nearest hundred.",
        icon: "🔄",
        cardType: "round-to-nearest-hundred-worksheet",
        roundToNearestHundredWorksheet: {
          items: [
            { label: "a", number: "102", answer: "100" },
            { label: "b", number: "167", answer: "200" },
            { label: "c", number: "674", answer: "700" },
            { label: "d", number: "345", answer: "300" },
            { label: "e", number: "2121", answer: "2100" },
            { label: "f", number: "1734", answer: "1700" },
          ],
        },
        examples: [
          {
            roundToNearestHundredWorksheet: {
              items: [
                { label: "a", number: "148", answer: "100" },
                { label: "b", number: "250", answer: "300" },
                { label: "c", number: "891", answer: "900" },
              ],
            },
          },
          {
            roundToNearestHundredWorksheet: {
              items: [
                { label: "a", number: "450", answer: "500" },
                { label: "b", number: "1250", answer: "1300" },
                { label: "c", number: "1999", answer: "2000" },
              ],
            },
          },
        ],
      },
      {
        title: "Fill in the missing numbers",
        description: "Fill in the missing numbers (place value / expanded form).",
        icon: "📝",
        cardType: "fill-missing-numbers-worksheet",
        fillMissingNumbersWorksheet: {
          items: [
            { label: "a", equation: "34 = ___ + 4", answer: "30" },
            { label: "b", equation: "198 = ___ + 90 + 8", answer: "100" },
            { label: "c", equation: "356 = ___ + 50 + 6", answer: "300" },
            { label: "d", equation: "1232 = 1000 + ___ + 30 + 2", answer: "200" },
          ],
        },
        examples: [
          {
            fillMissingNumbersWorksheet: {
              items: [
                { label: "a", equation: "52 = ___ + 2", answer: "50" },
                { label: "b", equation: "405 = 400 + ___ + 5", answer: "0" },
              ],
            },
          },
          {
            fillMissingNumbersWorksheet: {
              items: [
                { label: "a", equation: "78 = 70 + ___", answer: "8" },
                { label: "b", equation: "2507 = 2000 + ___ + 7", answer: "500" },
              ],
            },
          },
        ],
      },
      {
        title: "Complete the number bonds below",
        description: "Complete the number bonds (fill in the missing number).",
        icon: "🔗",
        cardType: "number-bonds-worksheet",
        numberBondsWorksheet: {
          items: [
            { label: "a", equation: "2 + ___ = 4 + 5", answer: "7" },
            { label: "b", equation: "1 + 6 = ___ + 3", answer: "4" },
            { label: "c", equation: "___ + 1 = 5 + 6", answer: "10" },
          ],
        },
        examples: [
          {
            numberBondsWorksheet: {
              items: [
                { label: "a", equation: "3 + ___ = 2 + 4", answer: "3" },
                { label: "b", equation: "8 + 2 = ___ + 5", answer: "5" },
              ],
            },
          },
          {
            numberBondsWorksheet: {
              items: [
                { label: "a", equation: "___ + 4 = 7 + 3", answer: "6" },
                { label: "b", equation: "9 + 1 = 6 + ___", answer: "4" },
              ],
            },
          },
        ],
      },
      {
        title: "Write the numbers as two pairs of number bonds",
        description: "Write each number as two separate pairs of number bonds.",
        icon: "🔗",
        cardType: "number-bonds-pairs-worksheet",
        numberBondsPairsWorksheet: {
          example: "10 = 8 + 2 = 5 + 5",
          items: [
            { label: "a", number: "20", answer: "15 + 5 = 10 + 10" },
            { label: "b", number: "12", answer: "10 + 2 = 6 + 6" },
            { label: "c", number: "31", answer: "20 + 11 = 15 + 16" },
          ],
        },
        examples: [
          {
            numberBondsPairsWorksheet: {
              example: "8 = 6 + 2 = 4 + 4",
              items: [
                { label: "a", number: "15", answer: "10 + 5 = 8 + 7" },
                { label: "b", number: "24", answer: "20 + 4 = 12 + 12" },
              ],
            },
          },
          {
            numberBondsPairsWorksheet: {
              example: "6 = 4 + 2 = 3 + 3",
              items: [{ label: "a", number: "18", answer: "10 + 8 = 9 + 9" }],
            },
          },
        ],
      },
      {
        title: "Use the partition method to complete the sums",
        description: "Use the partition method to complete the sums below.",
        icon: "➕",
        cardType: "partition-method-worksheet",
        partitionMethodWorksheet: {
          instruction: "Use the partition method to complete the sums below.",
          items: [
            { label: "a", sum: "201 + 142", answer: "343" },
            { label: "b", sum: "653 + 126", answer: "779" },
            { label: "c", sum: "383 + 29", answer: "412" },
            { label: "d", sum: "440 + 654", answer: "1094" },
          ],
        },
        examples: [
          {
            partitionMethodWorksheet: {
              instruction: "Use the partition method to complete the sums below.",
              items: [
                { label: "a", sum: "45 + 32", answer: "77" },
                { label: "b", sum: "128 + 51", answer: "179" },
              ],
            },
          },
          {
            partitionMethodWorksheet: {
              instruction: "Use the partition method to complete the sums below.",
              items: [
                { label: "a", sum: "305 + 240", answer: "545" },
                { label: "b", sum: "156 + 78", answer: "234" },
              ],
            },
          },
        ],
      },
    ],
    "number-lines": [
      {
        title: "Number line",
        description: "A line with numbers placed at equal intervals, used to show order and value.",
        icon: "📏",
        cardType: "number-line",
        numberLine: {
          min: 0,
          max: 10,
          markedValue: 4,
          readTip: "The dot shows the value 4. Start at 0 and count 4 steps to the right — that is the value at the dot.",
          drawTip: "1) Draw a horizontal line. 2) Mark equal gaps along it. 3) Label the marks 0, 1, 2, 3, … from left to right. 4) To show a value, put a dot above that number.",
        },
        examples: [
          {
            numberLine: {
              min: 0,
              max: 10,
              markedValue: 4,
              readTip: "The dot shows the value 4. Start at 0 and count 4 steps to the right — that is the value at the dot.",
              drawTip: "1) Draw a horizontal line. 2) Mark equal gaps along it. 3) Label the marks 0, 1, 2, 3, … from left to right. 4) To show a value, put a dot above that number.",
            },
          },
          {
            numberLine: {
              min: 0,
              max: 5,
              markedValue: 2,
              readTip: "The dot is above the mark labeled 2, so the value is 2. Numbers get bigger as you go right.",
              drawTip: "1) Draw a straight horizontal line. 2) Make equal spaces (e.g. use a ruler). 3) Write 0 at the start, then 1, 2, 3, … at each mark. 4) Place a dot above the number you want to show.",
            },
          },
          {
            numberLine: {
              min: -2,
              max: 3,
              markedValue: 1,
              readTip: "Zero is in the middle. Left of 0 are negative numbers (−2, −1). The dot is at 1 — one step right of zero.",
              drawTip: "1) Draw a horizontal line. 2) Mark zero in the middle. 3) To the right label 1, 2, 3, …; to the left label −1, −2, −3, … 4) Put a dot above the number you mean.",
            },
          },
        ],
      },
      {
        title: "Illustrate sums on a number line",
        description: "Illustrate the sums on a number line. Start from the number on the left and work your way right (for +) or left (for −).",
        icon: "📏",
        cardType: "number-line-sums-worksheet",
        numberLineSumsWorksheet: {
          instruction: "Hint: Start from the numbers to left and work your way to the right.",
          items: [
            { label: "1", sum: "7 + 1", answer: "8", start: 7, end: 8 },
            { label: "2", sum: "5 + 3", answer: "8", start: 5, end: 8 },
            { label: "3", sum: "4 − 3", answer: "1", start: 4, end: 1 },
            { label: "4", sum: "5 − 1", answer: "4", start: 5, end: 4 },
            { label: "5", sum: "6 − 2", answer: "4", start: 6, end: 4 },
            { label: "6", sum: "8 − 1 + 2", answer: "9", start: 8, end: 9 },
            { label: "7", sum: "9 − 6 + 3", answer: "6", start: 9, end: 6 },
            { label: "8", sum: "6 + 1 − 5", answer: "2", start: 6, end: 2 },
            { label: "9", sum: "4 + 5 − 2", answer: "7", start: 4, end: 7 },
            { label: "10", sum: "3 + 4 − 5", answer: "2", start: 3, end: 2 },
          ],
        },
        examples: [
          { numberLineSumsWorksheet: { instruction: "Hint: Start from the numbers to left and work your way to the right.", items: [{ label: "1", sum: "7 + 1", answer: "8", start: 7, end: 8 }, { label: "2", sum: "5 + 3", answer: "8", start: 5, end: 8 }, { label: "3", sum: "4 − 3", answer: "1", start: 4, end: 1 }, { label: "4", sum: "5 − 1", answer: "4", start: 5, end: 4 }] } },
          { numberLineSumsWorksheet: { instruction: "Hint: Start from the numbers to left and work your way to the right.", items: [{ label: "5", sum: "6 − 2", answer: "4", start: 6, end: 4 }, { label: "6", sum: "8 − 1 + 2", answer: "9", start: 8, end: 9 }, { label: "7", sum: "9 − 6 + 3", answer: "6", start: 9, end: 6 }, { label: "8", sum: "6 + 1 − 5", answer: "2", start: 6, end: 2 }] } },
          { numberLineSumsWorksheet: { instruction: "Hint: Start from the numbers to left and work your way to the right.", items: [{ label: "9", sum: "4 + 5 − 2", answer: "7", start: 4, end: 7 }, { label: "10", sum: "3 + 4 − 5", answer: "2", start: 3, end: 2 }] } },
        ],
      },
    ],
    "arithmetic-operations": [
      {
        title: "Addition",
        description: "The answer you get when you add numbers together.",
        icon: "➕",
        cardType: "arithmetic",
        arithmetic: { op: "add", a: 7, b: 5, question: "What is 7 + 5?", answer: "12" },
        examples: [
          { arithmetic: { op: "add", a: 7, b: 5, question: "What is 7 + 5?", answer: "12" } },
          { arithmetic: { op: "add", a: 9, b: 3, question: "What is 9 + 3?", answer: "12" } },
          { arithmetic: { op: "add", a: 6, b: 4, question: "What is 6 + 4?", answer: "10" } },
        ],
      },
      {
        title: "Subtraction",
        description: "How much bigger one number is than another (answer to a subtraction).",
        icon: "➖",
        cardType: "arithmetic",
        arithmetic: { op: "subtract", a: 12, b: 5, question: "What is 12 − 5?", answer: "7" },
        examples: [
          { arithmetic: { op: "subtract", a: 12, b: 5, question: "What is 12 − 5?", answer: "7" } },
          { arithmetic: { op: "subtract", a: 15, b: 7, question: "What is 15 − 7?", answer: "8" } },
          { arithmetic: { op: "subtract", a: 20, b: 9, question: "What is 20 − 9?", answer: "11" } },
        ],
      },
      {
        title: "Multiplication",
        description: "The answer you get when you multiply numbers.",
        icon: "✖️",
        cardType: "arithmetic",
        arithmetic: { op: "multiply", a: 4, b: 3, question: "What is 4 × 3?", answer: "12" },
        examples: [
          { arithmetic: { op: "multiply", a: 4, b: 3, question: "What is 4 × 3?", answer: "12" } },
          { arithmetic: { op: "multiply", a: 5, b: 2, question: "What is 5 × 2?", answer: "10" } },
          { arithmetic: { op: "multiply", a: 3, b: 6, question: "What is 3 × 6?", answer: "18" } },
        ],
      },
      {
        title: "Division",
        description: "The answer you get when you divide one number by another.",
        icon: "➗",
        cardType: "arithmetic",
        arithmetic: { op: "divide", a: 12, b: 3, question: "What is 12 ÷ 3?", answer: "4" },
        examples: [
          { arithmetic: { op: "divide", a: 12, b: 3, question: "What is 12 ÷ 3?", answer: "4" } },
          { arithmetic: { op: "divide", a: 15, b: 5, question: "What is 15 ÷ 5?", answer: "3" } },
          { arithmetic: { op: "divide", a: 20, b: 4, question: "What is 20 ÷ 4?", answer: "5" } },
        ],
      },
    ],
    "fractions-decimals-percentages": [
      {
        title: "Fraction",
        description: "A way of showing part of a whole using a numerator over a denominator.",
        icon: "½",
        cardType: "fraction",
        fraction: { num: 3, den: 4, question: "How many parts are shaded?", answer: "3 out of 4" },
        examples: [
          { fraction: { num: 3, den: 4, question: "How many parts are shaded?", answer: "3 out of 4" } },
          { fraction: { num: 1, den: 2, question: "What fraction is shaded?", answer: "1 out of 2" } },
          { fraction: { num: 2, den: 5, question: "What fraction is shaded?", answer: "2 out of 5" } },
        ],
      },
      {
        title: "Decimal",
        description: "A number with a dot that separates whole parts from fractional parts.",
        icon: "🔢",
        cardType: "decimal",
        decimal: { value: 2.5, question: "What does 2.5 mean?", answer: "2 wholes and 5 tenths" },
        examples: [
          { decimal: { value: 2.5, question: "What does 2.5 mean?", answer: "2 wholes and 5 tenths" } },
          { decimal: { value: 3.2, question: "What does 3.2 mean?", answer: "3 wholes and 2 tenths" } },
          { decimal: { value: 1.75, question: "What does 1.75 mean?", answer: "1 whole and 75 hundredths" } },
        ],
      },
      {
        title: "Percent",
        description: "Means “out of 100”. For example, 25% is 25 out of 100.",
        icon: "%",
        cardType: "percent",
        percent: { value: 25, question: "What does 25% mean?", answer: "25 out of 100" },
        examples: [
          { percent: { value: 25, question: "What does 25% mean?", answer: "25 out of 100" } },
          { percent: { value: 50, question: "What does 50% mean?", answer: "50 out of 100 (half)" } },
          { percent: { value: 10, question: "What does 10% mean?", answer: "10 out of 100" } },
        ],
      },
    ],
    "ratio-proportion": [
      {
        title: "Ratio",
        description: "Compares two quantities using a colon.",
        icon: "2:3",
        cardType: "ratio",
        ratio: { a: 2, b: 3, question: "For every 2 red, there are 3 blue. What is the ratio?", answer: "2 : 3" },
        examples: [
          { ratio: { a: 2, b: 3, question: "For every 2 red, there are 3 blue. What is the ratio?", answer: "2 : 3" } },
          { ratio: { a: 1, b: 4, question: "For every 1 cat, there are 4 dogs. What is the ratio?", answer: "1 : 4" } },
          { ratio: { a: 3, b: 5, question: "For every 3 apples, there are 5 bananas. What is the ratio?", answer: "3 : 5" } },
        ],
      },
      {
        title: "Proportion",
        description: "Says that two ratios are equal.",
        icon: "⚖️",
        cardType: "proportion",
        proportion: { r1: [1, 2], r2: [2, 4], question: "Are 1:2 and 2:4 equal?", answer: "Yes, both equal ½" },
        examples: [
          { proportion: { r1: [1, 2], r2: [2, 4], question: "Are 1:2 and 2:4 equal?", answer: "Yes, both equal ½" } },
          { proportion: { r1: [2, 3], r2: [4, 6], question: "Are 2:3 and 4:6 equal?", answer: "Yes, both equal ⅔" } },
          { proportion: { r1: [3, 5], r2: [6, 10], question: "Are 3:5 and 6:10 equal?", answer: "Yes, both equal 3/5" } },
        ],
      },
      {
        title: "Sharing in a ratio",
        description: "Splitting an amount into parts that match a given ratio.",
        icon: "🔀",
        cardType: "sharing-ratio",
        sharingRatio: { total: 10, ratio: [2, 3], question: "Share 10 in ratio 2:3. How many does each get?", answer: "4 and 6" },
        examples: [
          { sharingRatio: { total: 10, ratio: [2, 3], question: "Share 10 in ratio 2:3. How many does each get?", answer: "4 and 6" } },
          { sharingRatio: { total: 15, ratio: [1, 2], question: "Share 15 in ratio 1:2.", answer: "5 and 10" } },
          { sharingRatio: { total: 20, ratio: [3, 2], question: "Share 20 in ratio 3:2.", answer: "12 and 8" } },
        ],
      },
    ],
    "algebra-basics": [
      {
        title: "Variable",
        description: "A symbol (often a letter like x) that stands for an unknown number.",
        icon: "x",
        cardType: "equation",
        equation: { expr: "x + 5 = 12", question: "What is x?", answer: "7" },
        examples: [
          { equation: { expr: "x + 5 = 12", question: "What is x?", answer: "7" } },
          { equation: { expr: "x - 3 = 4", question: "What is x?", answer: "7" } },
          { equation: { expr: "2x = 10", question: "What is x?", answer: "5" } },
        ],
      },
      {
        title: "Expression",
        description: "Numbers, symbols and operations written together.",
        icon: "3x+5",
        cardType: "expression",
        expression: { expr: "3x + 5", question: "If x = 2, what is 3x + 5?", answer: "11" },
        examples: [
          { expression: { expr: "3x + 5", question: "If x = 2, what is 3x + 5?", answer: "11" } },
          { expression: { expr: "2x + 1", question: "If x = 4, what is 2x + 1?", answer: "9" } },
          { expression: { expr: "5x - 3", question: "If x = 3, what is 5x - 3?", answer: "12" } },
        ],
      },
      {
        title: "Equation",
        description: "A maths sentence with an equals sign.",
        icon: "=",
        cardType: "equation",
        equation: { expr: "2x = 10", question: "What is x?", answer: "5" },
        examples: [
          { equation: { expr: "2x = 10", question: "What is x?", answer: "5" } },
          { equation: { expr: "x + 3 = 9", question: "What is x?", answer: "6" } },
          { equation: { expr: "3x = 15", question: "What is x?", answer: "5" } },
        ],
      },
    ],
    "geometry-shape": [
      {
        title: "Right angle",
        description: "An angle that measures exactly 90° – like the corner of a square.",
        icon: "∟",
        cardType: "angle",
        angle: { type: "right", question: "What size is this angle?", answer: "90°" },
        examples: [
          { angle: { type: "right", question: "What size is this angle?", answer: "90°" } },
          { angle: { type: "right", question: "Is a right angle more or less than 90°?", answer: "Exactly 90°" } },
          { angle: { type: "right", question: "What do we call a 90° angle?", answer: "A right angle" } },
        ],
      },
      {
        title: "Acute angle",
        description: "An angle that is less than 90° (sharp and narrow).",
        icon: "∠",
        cardType: "angle",
        angle: { type: "acute", question: "Is this angle less or more than 90°?", answer: "Less than 90°" },
        examples: [
          { angle: { type: "acute", question: "Is this angle less or more than 90°?", answer: "Less than 90°" } },
          { angle: { type: "acute", question: "What do we call angles smaller than 90°?", answer: "Acute angles" } },
          { angle: { type: "acute", question: "Is a 45° angle acute, right or obtuse?", answer: "Acute" } },
        ],
      },
      {
        title: "Obtuse angle",
        description: "An angle that is more than 90° but less than 180°.",
        icon: "∠",
        cardType: "angle",
        angle: { type: "obtuse", question: "Is this angle less or more than 90°?", answer: "More than 90°, less than 180°" },
        examples: [
          { angle: { type: "obtuse", question: "Is this angle less or more than 90°?", answer: "More than 90°, less than 180°" } },
          { angle: { type: "obtuse", question: "Is a 120° angle acute, right or obtuse?", answer: "Obtuse" } },
          { angle: { type: "obtuse", question: "Are obtuse angles bigger or smaller than right angles?", answer: "Bigger" } },
        ],
      },
    ],
    measurement: [
      {
        title: "Perimeter",
        description: "The distance all the way around the outside of a 2D shape.",
        icon: "📏",
        cardType: "perimeter",
        perimeter: { shape: "rectangle", w: 4, h: 3, question: "What is the perimeter?", answer: "14 units" },
        examples: [
          { perimeter: { shape: "rectangle", w: 4, h: 3, question: "What is the perimeter?", answer: "14 units" } },
          { perimeter: { shape: "rectangle", w: 5, h: 2, question: "What is the perimeter?", answer: "14 units" } },
          { perimeter: { shape: "rectangle", w: 6, h: 1, question: "What is the perimeter?", answer: "14 units" } },
        ],
      },
      {
        title: "Area",
        description: "The amount of space inside a 2D shape.",
        icon: "▢",
        cardType: "area",
        area: { shape: "rectangle", w: 4, h: 3, question: "What is the area?", answer: "12 square units" },
        examples: [
          { area: { shape: "rectangle", w: 4, h: 3, question: "What is the area?", answer: "12 square units" } },
          { area: { shape: "rectangle", w: 6, h: 2, question: "What is the area?", answer: "12 square units" } },
          { area: { shape: "rectangle", w: 3, h: 3, question: "What is the area?", answer: "9 square units" } },
        ],
      },
      {
        title: "Volume",
        description: "The amount of 3D space something takes up.",
        icon: "📦",
        cardType: "volume",
        volume: { l: 2, w: 2, h: 3, question: "How many unit cubes?", answer: "12 cubes" },
        examples: [
          { volume: { l: 2, w: 2, h: 3, question: "How many unit cubes?", answer: "12 cubes" } },
          { volume: { l: 3, w: 2, h: 2, question: "How many unit cubes?", answer: "12 cubes" } },
          { volume: { l: 2, w: 3, h: 3, question: "How many unit cubes?", answer: "18 cubes" } },
        ],
      },
    ],
    "statistics-data": [
      {
        title: "Mean",
        description: "The 'average' found by adding all values and dividing by how many there are.",
        icon: "📊",
        cardType: "statistics",
        statistics: { type: "mean", values: [2, 4, 6], question: "What is the mean?", answer: "4" },
        examples: [
          { statistics: { type: "mean", values: [2, 4, 6], question: "What is the mean?", answer: "4" } },
          { statistics: { type: "mean", values: [1, 3, 5], question: "What is the mean?", answer: "3" } },
          { statistics: { type: "mean", values: [4, 6, 10], question: "What is the mean?", answer: "6.67 (approx)" } },
        ],
      },
      {
        title: "Mode",
        description: "The value that appears most often in a data set.",
        icon: "📊",
        cardType: "statistics",
        statistics: { type: "mode", values: [3, 5, 5, 7], question: "What is the mode?", answer: "5" },
        examples: [
          { statistics: { type: "mode", values: [3, 5, 5, 7], question: "What is the mode?", answer: "5" } },
          { statistics: { type: "mode", values: [1, 2, 2, 2, 3], question: "What is the mode?", answer: "2" } },
          { statistics: { type: "mode", values: [4, 4, 6, 6, 6, 8], question: "What is the mode?", answer: "6" } },
        ],
      },
      {
        title: "Range",
        description: "The difference between the largest and smallest values.",
        icon: "↔️",
        cardType: "statistics",
        statistics: { type: "range", values: [2, 5, 9], question: "What is the range?", answer: "7" },
        examples: [
          { statistics: { type: "range", values: [2, 5, 9], question: "What is the range?", answer: "7" } },
          { statistics: { type: "range", values: [1, 4, 6, 10], question: "What is the range?", answer: "9" } },
          { statistics: { type: "range", values: [3, 3, 3, 3], question: "What is the range?", answer: "0" } },
        ],
      },
    ],
    "problem-solving-reasoning": [
      {
        title: "Multi-step problem",
        description: "A question that needs more than one operation to solve.",
        icon: "1→2→3",
        cardType: "multi-step",
        multiStep: { steps: ["5 + 3 = 8", "8 ÷ 2 = ?"], question: "What is the answer?", answer: "4" },
        examples: [
          { multiStep: { steps: ["5 + 3 = 8", "8 ÷ 2 = ?"], question: "What is the answer?", answer: "4" } },
          { multiStep: { steps: ["10 − 2 = 8", "8 × 2 = ?"], question: "What is the answer?", answer: "16" } },
          { multiStep: { steps: ["3 × 4 = 12", "12 + 5 = ?"], question: "What is the answer?", answer: "17" } },
        ],
      },
      {
        title: "Estimate",
        description: "A sensible guess close to the exact answer.",
        icon: "≈",
        cardType: "estimate",
        estimate: { calc: "19 + 43", question: "Estimate the answer.", answer: "about 60" },
        examples: [
          { estimate: { calc: "19 + 43", question: "Estimate the answer.", answer: "about 60" } },
          { estimate: { calc: "51 + 29", question: "Estimate the answer.", answer: "about 80" } },
          { estimate: { calc: "102 − 49", question: "Estimate the answer.", answer: "about 50" } },
        ],
      },
      {
        title: "Logic puzzle",
        description: "Use clues and reasoning instead of long calculations.",
        icon: "🧩",
        cardType: "logic",
        logic: { clue: "Tom is taller than Sam. Sam is taller than Ben.", question: "Who is shortest?", answer: "Ben" },
        examples: [
          { logic: { clue: "Tom is taller than Sam. Sam is taller than Ben.", question: "Who is shortest?", answer: "Ben" } },
          { logic: { clue: "All squares are rectangles. All rectangles have 4 sides.", question: "How many sides does a square have?", answer: "4 sides" } },
          { logic: { clue: "Anna is older than Beth. Beth is older than Cara.", question: "Who is youngest?", answer: "Cara" } },
        ],
      },
    ],
  },
  english: {
    "reading-comprehension": [
      {
        title: "Inference",
        description: "Working out something not directly said using clues.",
        icon: "🔍",
        cardType: "inference",
        inference: { text: "Sarah wore her wellies and carried an umbrella.", question: "What can you infer about the weather?", answer: "It was raining" },
        examples: [
          { inference: { text: "Sarah wore her wellies and carried an umbrella.", question: "What can you infer about the weather?", answer: "It was raining" } },
          { inference: { text: "Tom put on his sunglasses and went to the beach.", question: "What can you infer about the weather?", answer: "It was sunny" } },
          { inference: { text: "The playground was empty and the lights were off.", question: "What can you infer about the time?", answer: "It was late or closed" } },
        ],
      },
      {
        title: "Main idea",
        description: "What a paragraph or text is mostly about.",
        icon: "💡",
        cardType: "main-idea",
        mainIdea: { text: "Dogs need exercise, food and love.", question: "What is the main idea?", answer: "How to care for dogs" },
        examples: [
          { mainIdea: { text: "Dogs need exercise, food and love.", question: "What is the main idea?", answer: "How to care for dogs" } },
          { mainIdea: { text: "Plants need sunlight and water to grow.", question: "What is the main idea?", answer: "What plants need to grow" } },
          { mainIdea: { text: "Brushing your teeth keeps them strong and healthy.", question: "What is the main idea?", answer: "Why brushing teeth is important" } },
        ],
      },
    ],
    vocabulary: [
      {
        title: "Synonym",
        description: "A word that has the same or nearly the same meaning.",
        icon: "↔️",
        cardType: "word-pair",
        wordPair: { word1: "happy", word2: "cheerful", type: "synonym", question: "What do we call words with the same meaning?", answer: "Synonyms" },
        examples: [
          { wordPair: { word1: "happy", word2: "cheerful", type: "synonym", question: "What do we call words with the same meaning?", answer: "Synonyms" } },
          { wordPair: { word1: "big", word2: "large", type: "synonym", question: "What do we call words with the same meaning?", answer: "Synonyms" } },
          { wordPair: { word1: "quick", word2: "fast", type: "synonym", question: "What do we call words with the same meaning?", answer: "Synonyms" } },
        ],
      },
      {
        title: "Antonym",
        description: "A word that has the opposite meaning.",
        icon: "⇄",
        cardType: "word-pair",
        wordPair: { word1: "hot", word2: "cold", type: "antonym", question: "What do we call words with opposite meanings?", answer: "Antonyms" },
        examples: [
          { wordPair: { word1: "hot", word2: "cold", type: "antonym", question: "What do we call words with opposite meanings?", answer: "Antonyms" } },
          { wordPair: { word1: "up", word2: "down", type: "antonym", question: "What do we call words with opposite meanings?", answer: "Antonyms" } },
          { wordPair: { word1: "day", word2: "night", type: "antonym", question: "What do we call words with opposite meanings?", answer: "Antonyms" } },
        ],
      },
    ],
    spelling: [
      {
        title: "Prefix",
        description: "Letters added to the start of a word to change its meaning.",
        icon: "un-",
        cardType: "prefix-suffix",
        prefixSuffix: { type: "prefix", part: "un", word: "happy", result: "unhappy", question: "What does un- do?", answer: "Makes it the opposite" },
        examples: [
          { prefixSuffix: { type: "prefix", part: "un", word: "happy", result: "unhappy", question: "What does un- do?", answer: "Makes it the opposite" } },
          { prefixSuffix: { type: "prefix", part: "re", word: "play", result: "replay", question: "What does re- mean?", answer: "Do again" } },
          { prefixSuffix: { type: "prefix", part: "pre", word: "heat", result: "preheat", question: "What does pre- mean?", answer: "Before" } },
        ],
      },
      {
        title: "Suffix",
        description: "Letters added to the end of a word.",
        icon: "-ful",
        cardType: "prefix-suffix",
        prefixSuffix: { type: "suffix", part: "ful", word: "help", result: "helpful", question: "What does -ful mean?", answer: "Full of (e.g. full of help)" },
        examples: [
          { prefixSuffix: { type: "suffix", part: "ful", word: "help", result: "helpful", question: "What does -ful mean?", answer: "Full of (e.g. full of help)" } },
          { prefixSuffix: { type: "suffix", part: "less", word: "hope", result: "hopeless", question: "What does -less mean?", answer: "Without" } },
          { prefixSuffix: { type: "suffix", part: "est", word: "small", result: "smallest", question: "What does -est mean?", answer: "The most" } },
        ],
      },
    ],
    grammar: [
      {
        title: "Noun",
        description: "A word for a person, place, thing or idea.",
        icon: "📝",
        cardType: "noun-verb",
        nounVerb: { type: "noun", examples: ["teacher", "park", "pencil"], question: "Which word is a noun: run, book, quickly?", answer: "book" },
        examples: [
          { nounVerb: { type: "noun", examples: ["teacher", "park", "pencil"], question: "Which word is a noun: run, book, quickly?", answer: "book" } },
          { nounVerb: { type: "noun", examples: ["river", "kindness", "city"], question: "Which word is a noun: river, slowly, blue?", answer: "river" } },
          { nounVerb: { type: "noun", examples: ["dog", "idea", "London"], question: "Which word is a noun: jump, dog, quickly?", answer: "dog" } },
        ],
      },
      {
        title: "Verb",
        description: "A doing or being word (action or state).",
        icon: "🏃",
        cardType: "noun-verb",
        nounVerb: { type: "verb", examples: ["run", "think", "is"], question: "Which word is a verb: dog, jump, big?", answer: "jump" },
        examples: [
          { nounVerb: { type: "verb", examples: ["run", "think", "is"], question: "Which word is a verb: dog, jump, big?", answer: "jump" } },
          { nounVerb: { type: "verb", examples: ["swim", "sleep", "write"], question: "Which word is a verb: slowly, swim, cloud?", answer: "swim" } },
          { nounVerb: { type: "verb", examples: ["laugh", "is", "feel"], question: "Which word is a verb: chair, laugh, red?", answer: "laugh" } },
        ],
      },
    ],
    punctuation: [
      {
        title: "Comma",
        description: "A punctuation mark (,) used to separate items in a list or parts of a sentence.",
        icon: ",",
        examples: [
          {},
          {},
          {},
        ],
      },
      {
        title: "Apostrophe",
        description: "A punctuation mark (’) used for contractions (don’t) or to show possession (Sam’s book).",
        examples: [
          {},
          {},
          {},
        ],
      },
    ],
    "creative-writing": [
      {
        title: "Opening hook",
        description: "The start of a story that grabs the reader’s attention.",
        examples: [{}, {}, {}],
      },
      { title: "Setting", description: "Where and when a story takes place.", icon: "🏠", examples: [{}, {}, {}] },
    ],
    "cloze-sentence-completion": [
      { title: "Context clue", description: "Words around a gap that help you guess the missing word.", icon: "🔎", examples: [{}, {}, {}] },
      { title: "Connective", description: "A word or phrase that links ideas, like because, however, therefore.", icon: "🔗", examples: [{}, {}, {}] },
    ],
    "language-techniques": [
      {
        title: "Simile",
        description: "A comparison using ‘like’ or ‘as’, e.g. as brave as a lion.",
        examples: [{}, {}, {}],
      },
      { title: "Metaphor", description: "Says something is something else to create an image, e.g. the classroom was a zoo.", icon: "🖼️", examples: [{}, {}, {}] },
    ],
  },
  "verbal-reasoning": {
    "word-relationships": [
      {
        title: "Analogy",
        description: "A pair of words with a relationship.",
        icon: "🔗",
        cardType: "analogy",
        analogy: { pair1: ["cat", "kitten"], pair2: ["dog", "?"], question: "Complete the analogy: cat is to kitten as dog is to?", answer: "puppy" },
        examples: [
          { analogy: { pair1: ["cat", "kitten"], pair2: ["dog", "?"], question: "Complete the analogy: cat is to kitten as dog is to?", answer: "puppy" } },
          { analogy: { pair1: ["teacher", "school"], pair2: ["doctor", "?"], question: "Complete the analogy: teacher is to school as doctor is to?", answer: "hospital" } },
          { analogy: { pair1: ["up", "down"], pair2: ["left", "?"], question: "Complete the analogy: up is to down as left is to?", answer: "right" } },
        ],
      },
      {
        title: "Homonym",
        description: "Same spelling and sound, different meanings (e.g. bat).",
        icon: "🔊",
        cardType: "homonym",
        homonym: { word: "bat", meaning1: "flying animal", meaning2: "sports equipment", question: "What is a homonym for bat?", answer: "animal or sports equipment" },
        examples: [
          { homonym: { word: "bat", meaning1: "flying animal", meaning2: "sports equipment", question: "What is a homonym for bat?", answer: "animal or sports equipment" } },
          { homonym: { word: "park", meaning1: "place to play", meaning2: "to leave a car", question: "What are two meanings of park?", answer: "Play area and leave a car" } },
          { homonym: { word: "bark", meaning1: "sound a dog makes", meaning2: "tree covering", question: "What are two meanings of bark?", answer: "Dog sound and tree covering" } },
        ],
      },
    ],
    "alphabet-letter-logic": [
      {
        title: "Letter sequence",
        description: "Letters that follow a pattern.",
        icon: "ABC",
        cardType: "letter-sequence",
        letterSequence: { letters: ["A", "C", "E", "G"], rule: "skip one", question: "What comes next?", answer: "I" },
        examples: [
          { letterSequence: { letters: ["A", "C", "E", "G"], rule: "skip one", question: "What comes next?", answer: "I" } },
          { letterSequence: { letters: ["B", "D", "F"], rule: "skip one", question: "What comes next?", answer: "H" } },
          { letterSequence: { letters: ["M", "O", "Q"], rule: "skip one", question: "What comes next?", answer: "S" } },
        ],
      },
      {
        title: "Code shift",
        description: "Each letter moved forward or backward in the alphabet.",
        icon: "🔤",
        cardType: "code-shift",
        codeShift: { encoded: "IFMMP", shift: 1, question: "If A=B, B=C... what does IFMMP mean?", answer: "HELLO" },
        examples: [
          { codeShift: { encoded: "IFMMP", shift: 1, question: "If A=B, B=C... what does IFMMP mean?", answer: "HELLO" } },
          { codeShift: { encoded: "NZOP", shift: 1, question: "If A=B, what does NZOP mean?", answer: "MYNO" } },
          { codeShift: { encoded: "CZGGJ", shift: -1, question: "If B=A, C=B... what does CZGGJ mean?", answer: "BEEFI" } },
        ],
      },
    ],
    "word-puzzles": [
      {
        title: "Anagram",
        description: "A word made by rearranging the letters of another word.",
        icon: "🔀",
        cardType: "anagram",
        anagram: { word: "listen", scrambled: "silent", question: "Rearrange the letters to make a new word.", answer: "listen or silent" },
        examples: [
          { anagram: { word: "listen", scrambled: "silent", question: "Rearrange the letters to make a new word.", answer: "listen or silent" } },
          { anagram: { word: "earth", scrambled: "heart", question: "Rearrange the letters to make a new word.", answer: "earth or heart" } },
          { anagram: { word: "evil", scrambled: "live", question: "Rearrange the letters to make a new word.", answer: "evil or live" } },
        ],
      },
      {
        title: "Compound word",
        description: "A word made from two smaller words.",
        icon: "1+1",
        cardType: "compound",
        compound: { part1: "tooth", part2: "paste", word: "toothpaste", question: "What word do these make?", answer: "toothpaste" },
        examples: [
          { compound: { part1: "tooth", part2: "paste", word: "toothpaste", question: "What word do these make?", answer: "toothpaste" } },
          { compound: { part1: "rain", part2: "bow", word: "rainbow", question: "What word do these make?", answer: "rainbow" } },
          { compound: { part1: "foot", part2: "ball", word: "football", question: "What word do these make?", answer: "football" } },
        ],
      },
    ],
    "codes-logic": [
      {
        title: "Letter–number code",
        description: "Letters match numbers (A=1, B=2, C=3).",
        icon: "A=1",
        cardType: "letter-code",
        letterCode: { word: "CAT", values: [3, 1, 20], question: "What is the value of CAT? (A=1, B=2...)", answer: "24" },
        examples: [
          { letterCode: { word: "CAT", values: [3, 1, 20], question: "What is the value of CAT? (A=1, B=2...)", answer: "24" } },
          { letterCode: { word: "DOG", values: [4, 15, 7], question: "What is the value of DOG?", answer: "26" } },
          { letterCode: { word: "BED", values: [2, 5, 4], question: "What is the value of BED?", answer: "11" } },
        ],
      },
      {
        title: "Rule table",
        description: "A table showing how shapes, letters or numbers change.",
        icon: "📋",
        cardType: "rule-table",
        ruleTable: { input: "A→B, B→C", question: "If A becomes B, what does C become?", answer: "D" },
        examples: [
          { ruleTable: { input: "A→B, B→C", question: "If A becomes B, what does C become?", answer: "D" } },
          { ruleTable: { input: "1→2, 2→3", question: "If 3 follows 2, what comes after 3?", answer: "4" } },
          { ruleTable: { input: "▲→■, ■→●", question: "If ▲ becomes ■, what does ■ become?", answer: "●" } },
        ],
      },
    ],
    "sequence-pattern": [
      {
        title: "Term",
        description: "Each item in a sequence.",
        icon: "2,4,6,8",
        cardType: "sequence",
        sequence: { terms: [2, 4, 6, 8], rule: "+2", question: "What comes next?", answer: "10" },
        examples: [
          { sequence: { terms: [2, 4, 6, 8], rule: "+2", question: "What comes next?", answer: "10" } },
          { sequence: { terms: [5, 10, 15], rule: "+5", question: "What comes next?", answer: "20" } },
          { sequence: { terms: [1, 3, 5], rule: "+2", question: "What comes next?", answer: "7" } },
        ],
      },
      {
        title: "Rule of sequence",
        description: "The operation that takes you from one term to the next.",
        icon: "+3",
        cardType: "sequence",
        sequence: { terms: [3, 6, 9, 12], rule: "+3", question: "What is the rule?", answer: "Add 3 each time" },
        examples: [
          { sequence: { terms: [3, 6, 9, 12], rule: "+3", question: "What is the rule?", answer: "Add 3 each time" } },
          { sequence: { terms: [10, 20, 30], rule: "+10", question: "What is the rule?", answer: "Add 10 each time" } },
          { sequence: { terms: [100, 90, 80], rule: "-10", question: "What is the rule?", answer: "Subtract 10 each time" } },
        ],
      },
    ],
    "comprehension-inference": [
      {
        title: "Fact",
        description: "Something that can be proven true or false.",
        icon: "✓",
        cardType: "fact-opinion",
        factOpinion: { type: "fact", statement: "London is the capital of England.", question: "Is this a fact or opinion?", answer: "Fact" },
        examples: [
          { factOpinion: { type: "fact", statement: "London is the capital of England.", question: "Is this a fact or opinion?", answer: "Fact" } },
          { factOpinion: { type: "fact", statement: "Water freezes at 0°C.", question: "Is this a fact or opinion?", answer: "Fact" } },
          { factOpinion: { type: "fact", statement: "Spiders have eight legs.", question: "Is this a fact or opinion?", answer: "Fact" } },
        ],
      },
      {
        title: "Opinion",
        description: "What someone thinks or feels.",
        icon: "💭",
        cardType: "fact-opinion",
        factOpinion: { type: "opinion", statement: "Chocolate is the best flavour.", question: "Is this a fact or opinion?", answer: "Opinion" },
        examples: [
          { factOpinion: { type: "opinion", statement: "Chocolate is the best flavour.", question: "Is this a fact or opinion?", answer: "Opinion" } },
          { factOpinion: { type: "opinion", statement: "Football is more fun than cricket.", question: "Is this a fact or opinion?", answer: "Opinion" } },
          { factOpinion: { type: "opinion", statement: "Maths is the easiest subject.", question: "Is this a fact or opinion?", answer: "Opinion" } },
        ],
      },
    ],
  },
  "non-verbal-reasoning": {
    "pattern-sequence": [
      {
        title: "Shape pattern",
        description: "A repeating order of shapes that follows a rule.",
        icon: "◆◆◆",
        cardType: "shape-pattern",
        shapePattern: { shapes: ["◆", "●", "◆", "●"], question: "What comes next?", answer: "◆" },
        examples: [
          { shapePattern: { shapes: ["◆", "●", "◆", "●"], question: "What comes next?", answer: "◆" } },
          { shapePattern: { shapes: ["▲", "■", "▲", "■"], question: "What comes next?", answer: "▲" } },
          { shapePattern: { shapes: ["●", "●", "◆", "◆"], question: "What comes next?", answer: "●" } },
        ],
      },
      {
        title: "Term position",
        description: "Where an item appears in a pattern.",
        icon: "1️⃣",
        cardType: "shape-pattern",
        shapePattern: { shapes: ["▲", "■", "●", "▲"], question: "What is the 4th shape?", answer: "▲" },
        examples: [
          { shapePattern: { shapes: ["▲", "■", "●", "▲"], question: "What is the 4th shape?", answer: "▲" } },
          { shapePattern: { shapes: ["●", "◆", "●", "◆"], question: "What is the 3rd shape?", answer: "●" } },
          { shapePattern: { shapes: ["■", "■", "■", "●"], question: "What is the 2nd shape?", answer: "■" } },
        ],
      },
    ],
    "shape-analogies": [
      {
        title: "Analogy pair",
        description: "Two shapes linked by a change.",
        icon: "◆→◆",
        cardType: "shape-analogy",
        shapeAnalogy: { from: "◆", to: "◆●", change: "add dot", question: "If ◆→◆●, what does ■ become?", answer: "■●" },
        examples: [
          { shapeAnalogy: { from: "◆", to: "◆●", change: "add dot", question: "If ◆→◆●, what does ■ become?", answer: "■●" } },
          { shapeAnalogy: { from: "▲", to: "▲▲", change: "double shape", question: "If ▲→▲▲, what does ● become?", answer: "●●" } },
          { shapeAnalogy: { from: "■", to: "■◼", change: "add shading", question: "If ■→■◼, what does ▲ become?", answer: "▲◼" } },
        ],
      },
      {
        title: "Transformation",
        description: "A change like rotation, reflection or shading.",
        icon: "🔄",
        cardType: "transformation",
        transformation: { type: "rotation", question: "What happens when we rotate a shape 90°?", answer: "It turns a quarter turn" },
        examples: [
          { transformation: { type: "rotation", question: "What happens when we rotate a shape 90°?", answer: "It turns a quarter turn" } },
          { transformation: { type: "reflection", question: "What happens when we reflect a shape in a mirror line?", answer: "It flips to a mirror image" } },
          { transformation: { type: "translation", question: "What happens when we slide a shape?", answer: "It moves without turning" } },
        ],
      },
    ],
    "odd-one-out": [
      {
        title: "Odd one out",
        description: "The item that does not fit the rule.",
        icon: "❌",
        cardType: "odd-one-out",
        oddOneOut: { items: ["◆", "◆", "◆", "●"], question: "Which shape is the odd one out?", answer: "● (the circle)" },
        examples: [
          { oddOneOut: { items: ["◆", "◆", "◆", "●"], question: "Which shape is the odd one out?", answer: "● (the circle)" } },
          { oddOneOut: { items: ["▲", "▲", "■", "▲"], question: "Which shape is the odd one out?", answer: "■" } },
          { oddOneOut: { items: ["●", "■", "■", "■"], question: "Which shape is the odd one out?", answer: "●" } },
        ],
      },
      {
        title: "Common feature",
        description: "A property most shapes share.",
        icon: "▪️",
        cardType: "common-feature",
        commonFeature: { shapes: ["▲", "■", "◆"], question: "What do these shapes have in common?", answer: "All have straight sides" },
        examples: [
          { commonFeature: { shapes: ["▲", "■", "◆"], question: "What do these shapes have in common?", answer: "All have straight sides" } },
          { commonFeature: { shapes: ["●", "◆", "■"], question: "What do these shapes have in common?", answer: "All are 2D shapes" } },
          { commonFeature: { shapes: ["▲", "◆"], question: "What do these shapes have in common?", answer: "Both are triangles" } },
        ],
      },
    ],
    "rotation-reflection": [
      {
        title: "Rotation",
        description: "Turning a shape around a fixed point.",
        icon: "↩️",
        cardType: "rotation-reflection",
        rotationReflection: { type: "rotation", shape: "▶", question: "Rotate ▶ 90° clockwise. What do you get?", answer: "▼" },
        examples: [
          { rotationReflection: { type: "rotation", shape: "▶", question: "Rotate ▶ 90° clockwise. What do you get?", answer: "▼" } },
          { rotationReflection: { type: "rotation", shape: "▲", question: "Rotate ▲ 180°. What do you get?", answer: "▼" } },
          { rotationReflection: { type: "rotation", shape: "■", question: "Rotate ■ 90°. What do you get?", answer: "■ (looks the same)" } },
        ],
      },
      {
        title: "Reflection",
        description: "Flipping a shape over a mirror line.",
        icon: "⇆",
        cardType: "rotation-reflection",
        rotationReflection: { type: "reflection", question: "What is a reflection?", answer: "A mirror image" },
        examples: [
          { rotationReflection: { type: "reflection", question: "What is a reflection?", answer: "A mirror image" } },
          { rotationReflection: { type: "reflection", shape: "▶", question: "Reflect ▶ in a vertical mirror line. What do you get?", answer: "◀" } },
          { rotationReflection: { type: "reflection", shape: "L", question: "Reflect L in a horizontal mirror line. What happens?", answer: "It turns upside down" } },
        ],
      },
    ],
    matrix: [
      {
        title: "Matrix",
        description: "A grid where patterns change across rows and columns.",
        icon: "⊞",
        cardType: "matrix",
        matrix: { grid: [["◆", "●"], ["●", "?"]], question: "What goes in the empty spot?", answer: "◆" },
        examples: [
          { matrix: { grid: [["◆", "●"], ["●", "?"]], question: "What goes in the empty spot?", answer: "◆" } },
          { matrix: { grid: [["▲", "■"], ["■", "?"]], question: "What goes in the empty spot?", answer: "▲" } },
          { matrix: { grid: [["1", "2"], ["2", "?"]], question: "What goes in the empty spot?", answer: "3" } },
        ],
      },
      {
        title: "Row / column rule",
        description: "How shapes change across a row or down a column.",
        icon: "⇅",
        cardType: "matrix",
        matrix: { grid: [["1", "2"], ["3", "?"]], question: "If each row adds 1, what is ?", answer: "4" },
        examples: [
          { matrix: { grid: [["1", "2"], ["3", "?"]], question: "If each row adds 1, what is ?", answer: "4" } },
          { matrix: { grid: [["2", "4"], ["3", "?"]], question: "If each column adds 1, what is ?", answer: "5" } },
          { matrix: { grid: [["▲", "▲▲"], ["◆", "?"]], question: "What goes in the empty spot?", answer: "◆◆" } },
        ],
      },
    ],
    "spatial-3d": [
      {
        title: "Net of a solid",
        description: "A 2D pattern that can be folded to make a 3D shape, like a cube.",
        icon: "📦",
        cardType: "spatial-3d",
        spatial3d: {
          kind: "net",
          solid: "cube",
          question: "Which 3D solid does this net fold into?",
          answer: "Cube",
        },
        examples: [
          {
            spatial3d: {
              kind: "net",
              solid: "cube",
              question: "Which 3D solid does this net fold into?",
              answer: "Cube",
            },
          },
          {
            spatial3d: {
              kind: "net",
              solid: "triangular prism",
              question: "This net makes which 3D solid?",
              answer: "Triangular prism",
            },
          },
        ],
      },
      {
        title: "Viewpoint",
        description: "How a 3D object looks from above, the side or from a different angle.",
        icon: "👁️",
        cardType: "spatial-3d",
        spatial3d: {
          kind: "view",
          question: "Which 3D stack matches this top view?",
          answer: "The stack with 3 cubes in an L-shape",
        },
        examples: [
          {
            spatial3d: {
              kind: "view",
              question: "From above, you see 3 cubes in an L-shape. Which side view matches?",
              answer: "The view showing 2 cubes in front and 1 behind",
            },
          },
          {
            spatial3d: {
              kind: "view",
              question: "From the side you see 3 cubes in a straight column. How many cubes are in the stack?",
              answer: "3 cubes",
            },
          },
        ],
      },
    ],
    "shape-codes": [
      { title: "Shape code", description: "A rule that gives shapes a value depending on features like sides or shading.", icon: "◆=1" },
      { title: "Rule combination", description: "Using more than one rule at the same time (e.g. colour + number of sides).", icon: "◆+◆" },
    ],
    "hidden-shapes": [
      { title: "Hidden shape", description: "A simple shape that is hidden inside a more complex picture.", icon: "🔍" },
      { title: "Composite shape", description: "A shape made by combining two or more simpler shapes.", icon: "◆+▲" },
    ],
  },
};

